import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import ProductList from "./components/ProductList";
import ProductCategories from "./pages/ProductCategories";
import Testing from "./pages/Testing";
import Header from "./components/Header";
import Footer from "./components/Footer";

import ScrollToTop from "./components/ScrollToTop";
import ProductDetail from "./pages/ProductDetail";

import ComingSoon from "./pages/ComingSoon";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/products" element={<ProductCategories />} />
          
          {/* Product Category Routes */}
          <Route path="/products/tractor" element={<ProductList categoryId="tractor" />} />
          <Route path="/products/logging_tools" element={<ProductList categoryId="logging_tools" />} />
          <Route path="/products/surface_system" element={<ProductList categoryId="surface_system" />} />
          <Route path="/products/downhole_accessories" element={<ProductList categoryId="downhole_accessories" />} />
          
          {/* Product Detail Route */}
          <Route path="/products/:category/:id" element={<ProductDetail />} />

          <Route path="/testing" element={<Testing />} />
          
          {/* Coming Soon Routes */}
          <Route path="/consultancy/wireline-qualification" element={<ComingSoon />} />
          <Route path="/consultancy/wireline-operation" element={<ComingSoon />} />
          <Route path="/consultancy/manufacturing" element={<ComingSoon />} />
          <Route path="/consultancy/ai-technology" element={<ComingSoon />} />
          <Route path="/resources/manpower" element={<ComingSoon />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
